import type { AuditLog } from 'app/developer-v3/hooks';

import {
  VERSION_ADDED_ACTION,
  VERSION_CHANGED_ACTION,
  VERSION_DELETED_ACTION,
  VERSION_BLOCKED_ACTION,
} from './constants';

// Since the app version change related audit logs (like "version changed")
// contain a `message` field that is the same as the `version` field,
// we blank out the `message` field for these logs to avoid redundancy.
export function filterAuditLogs(auditLogs: Array<AuditLog>) {
  return auditLogs?.map(log => ({
    ...log,
    message: [
      VERSION_ADDED_ACTION,
      VERSION_CHANGED_ACTION,
      VERSION_DELETED_ACTION,
      VERSION_BLOCKED_ACTION,
    ].includes(log.action)
      ? ''
      : log.message,
  }));
}
